<template
  ><div class="h-100">
    <b-row align-h="center" align-v="center" class="h-100">
      <b-col class="tsny_box-padding tsny_border-right col-auto">
        <b-row align-v="center">
          <b-col>
            <div class="tsny_header text-center">
              Composite Score
            </div>
            <div
              class="tsny_text text-center composite"
              :style="{ color: scoreReport.color }"
            >
              {{ scoreReport.compositeScore }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row
          :class="scoreReport.courseId === 'ACT' ? 'row-cols-2' : 'row-cols-1'"
        >
          <b-col
            v-for="section in sections"
            :key="section"
            class="tsny_box-padding"
          >
            <b-row>
              <b-col>
                <div class="tsny_text text-center">
                  {{ section }}
                </div>
                <div
                  class="tsny_text text-center score "
                  :style="{ color: scoreReport.color }"
                >
                  {{ scoreReport[section].scaledScore }}
                </div>
              </b-col>
            </b-row></b-col
          >
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Constants from "../../services/Constants";

export default {
  name: "CompositeScores",
  props: {
    scoreReport: {
      type: Object,
      default: null
    },
    isModule: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sections() {
      return Constants.EXAM_SECTIONS[this.scoreReport.courseId].SECTIONS;
    }
  }
};
</script>

<style scoped>
.composite {
  font-size: 63px;
}

.score {
  font-size: 37px;
}
</style>
